// Ai dang dung phan mem. Ca ung dung doc tu day, khong ai tu hoi backend rieng.

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { api, dangKyXuLy401 } from "./api";
import type { NguoiDung } from "./types";

interface AuthCtx {
  toi: NguoiDung | null;
  dangTai: boolean;
  coPhienPanel: boolean;
  napLai: () => Promise<void>;
  dat: (u: NguoiDung) => void;
  thoat: () => Promise<void>;
}

const Ctx = createContext<AuthCtx>({
  toi: null,
  dangTai: true,
  coPhienPanel: false,
  napLai: async () => {},
  dat: () => {},
  thoat: async () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [toi, setToi] = useState<NguoiDung | null>(null);
  const [coPhienPanel, setCoPhienPanel] = useState(false);
  const [dangTai, setDangTai] = useState(true);

  const napLai = useCallback(async () => {
    try {
      const r = await api.toi();
      setToi(r.nguoi_dung);
      setCoPhienPanel(r.co_phien_panel);
    } catch {
      setToi(null);
      setCoPhienPanel(false);
    } finally {
      setDangTai(false);
    }
  }, []);

  useEffect(() => {
    // Cookie het han giua chung -> moi loi goi API deu 401. Bat o mot cho roi
    // dua nguoi dung ve man hinh dang nhap, thay vi de tung trang bao loi rieng.
    dangKyXuLy401(() => {
      setToi(null);
      setCoPhienPanel(false);
    });
    void napLai();
  }, [napLai]);

  const thoat = useCallback(async () => {
    await api.dangXuat().catch(() => undefined);
    setToi(null);
    setCoPhienPanel(false);
  }, []);

  const gia = useMemo<AuthCtx>(
    () => ({
      toi,
      dangTai,
      coPhienPanel,
      napLai,
      dat: (u) => setToi(u),
      thoat,
    }),
    [toi, dangTai, coPhienPanel, napLai, thoat],
  );

  return <Ctx.Provider value={gia}>{children}</Ctx.Provider>;
}

export function useAuth() {
  return useContext(Ctx);
}
